import React, { useState, useEffect } from 'react';

let toastId = 0;
const listeners = new Set();

const Toast = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const listener = (newToasts) => setToasts([...newToasts]);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[200] pointer-events-none flex flex-col gap-2 items-center w-full px-4 max-w-md">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto px-6 py-3 rounded-full font-medium text-sm shadow-2xl flex items-center gap-2 animate-fade-up w-full justify-center ${
            toast.type === 'success' ? 'bg-green-600 text-white' :
            toast.type === 'error' ? 'bg-red-600 text-white' :
            toast.type === 'warning' ? 'bg-yellow-500 text-black' :
            'bg-primary text-white'
          }`}
          role="alert"
        >
          <span>{toast.icon}</span>
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
};

export const showToast = (message, type = 'info') => {
  const icons = { success: '✅', info: 'ℹ️', warning: '⚠️', error: '❌' };
  const id = ++toastId;
  const newToast = { id, message, type, icon: icons[type] || 'ℹ️' };

  const currentToasts = [];
  listeners.forEach(listener => {
    // Enviamos solo este toast nuevo temporalmente
    listener([newToast]);
  });

  setTimeout(() => {
    listeners.forEach(listener => listener([]));
  }, 3000);
};

export default Toast;
